// extracted by mini-css-extract-plugin
export default {"layout":"TermsConditionsConfirmationPopup__layout--1sa","innerContent":"TermsConditionsConfirmationPopup__innerContent--2JG","info":"TermsConditionsConfirmationPopup__info--3ZF"};